"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContactInfoBoxModal = exports.useContactInfoBox = void 0;
const translations_1 = require("../translations");
const features_1 = require("../features");
const tracker_1 = require("../tracker");
const useContactInfoBox = (params) => (0, features_1.useContactInfoBox)({
    ...params,
    translate: translations_1.translate,
    tracker: tracker_1.tracker,
});
exports.useContactInfoBox = useContactInfoBox;
const useContactInfoBoxModal = (params) => (0, features_1.useContactInfoBoxModal)({
    ...params,
    translate: translations_1.translate,
    tracker: tracker_1.tracker,
});
exports.useContactInfoBoxModal = useContactInfoBoxModal;
//# sourceMappingURL=index.js.map